export const isBlockingCheckbox = ['4', '2', '6', '9', '20'];
export const historyCheckbox = ['6', '9', '20'];
